
<!--US Page-->
<div class="dtfinsurance">
  <!--Announcement Banner Code-->
  <!-- <div class="dtf-alertpage"></div> -->


  <!--Banner-->
  <section class="mbfs-home-hero_2"
    style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Dynamic_Lease_Carousel_1140x400_1123.jpg);">
    <section class="mbfs-home-hero_2__header">
      <div class="shortrow">
        <div>
        <h2 class="mbfs-home-hero_2__header-subtitle">
          Welcome to ACM Portal
        </h2>
        <p class="mbfs-home-hero_2__header-text">
          Please click on the login button above to continue
        </p>
      </div>
        <!-- <div class="dtf-adminformpage"></div> -->
     </div>
    </section>
  </section>
</div>

<div *ngIf = "passwordResetFlag">
  <div class="dtf-passwordresetconfirmpage"></div>
</div> 
